/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CreatingInputs */

const en_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating...`)
};

const de_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird erstellt…`)
};

/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {CreatingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const creating = /** @type {((inputs?: CreatingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CreatingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creating(inputs)
	return de_creating(inputs)
});